export default "__VITE_ASSET__BPpul9y8__"